import React from "react";
import Section from "../components/Section";
import Button from "../components/Button";
import { Caption } from "../components/Typography";
import { createUseStyles } from "react-jss";
import { HorizontalLine, VerticalLine } from "../components/Lines";
import theme from "../style/theme";

const Curve = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 1440 305"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M705.411 305C471.991 305 427.366 0.0276006 9.02604e-05 0.0275879C8.23812 -0.0345457 963.433 0.0276166 1440 0.0276309C1024.65 0.0276185 938.832 305 705.411 305Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Head = () => (
  <>
    <title>Page Not Found</title>
  </>
);

const NotFoundPage = () => {
  const classes = useStyles();
  return (
    <Section grid className={classes.section}>
      <Head />
      <Curve className={classes.curve} />
      <div className={classes.horizontalLine}>
        <HorizontalLine extend />
      </div>
      <h1 className={classes.title}>Error—404 Page Not Found</h1>
      <Button to="/" className={classes.button}>
        Back To Home
      </Button>
      <Caption className={classes.caption}>Page not found</Caption>
      <Caption className={classes.caption}>Error 404</Caption>
      <div className={classes.verticalLine}>
        <VerticalLine animationOrigin="0%" extend />
      </div>
      <div className={classes.bottomLine}>
        <HorizontalLine extend />
      </div>
    </Section>
  );
};

const useStyles = createUseStyles({
  section: {
    height: "calc(100vh - 72px)",
    gridTemplateRows: "1fr",
  },
  curve: {
    gridColumn: "1 / span 4",
    margin: [0, -theme.gutter.sm, theme.spacing(10)],
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / span 7",
      margin: [0, -theme.gutter.md, theme.spacing(20)],
    },
  },
  horizontalLine: {
    position: "relative",
    gridColumn: "1 / span 4",
    gridRow: 2,
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / span 7",
    },
  },
  bottomLine: {
    position: "relative",
    gridColumn: "1 / span 4",
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / span 7",
    },
  },
  verticalLine: {
    gridRow: "3 / span 2",
    gridColumn: 4,
    position: "relative",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  title: {
    gridRow: 3,
    gridColumn: "1 / span 4",
    marginBottom: theme.spacing(10),
    maxWidth: 300,
    [theme.breakpoints.up("md")]: {
      maxWidth: 500,
      marginBottom: theme.spacing(20),
      gridColumn: "1 / span 4",
    },
  },
  button: {
    gridRow: 4,
    gridColumn: "1 / span 4",
    justifySelf: "start",
    height: 31,
  },
  caption: {
    display: "none",
    maxWidth: 50,
    gridRow: 3,
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
});

export default NotFoundPage;
